@if (activeView === 'versionControl') {
  <app-tdg-version-control
    class="d-block"
    (testCasePreviewEvent)="onTestCasePreview($event)"
  ></app-tdg-version-control>
} @else {
  <app-tdg-data-table
    class="h-100 d-block"
    (backToVersionHistory)="onBackToVersionControl()"
  ></app-tdg-data-table>
}
